import { useCallback } from 'react';
import { ethers } from 'ethers';
import { isAmountZeroEquivalent } from '@lib/utils';

function useIsInvalidReceiveAmount(): (
  receiveAmount: string,
  tokenAssetDecimals?: number
) => boolean {
  return useCallback(
    (receiveAmount: string, tokenAssetDecimals?: number): boolean => {
      try {
        const decimals = tokenAssetDecimals || 18;
        const parsedReceiveAmount = ethers.utils.parseUnits(
          receiveAmount,
          decimals
        );

        if (
          isAmountZeroEquivalent(receiveAmount) ||
          parsedReceiveAmount.isZero()
        ) {
          return true;
        }

        return parsedReceiveAmount.isNegative();
      } catch (err) {
        return true;
      }
    },
    []
  );
}

export default useIsInvalidReceiveAmount;
